var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H0V26H10V4C10 2.895 9.105 2 8 2Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.196 15.02L26.741 14.129L23.936 6.649C23.79 6.259 23.417 6 23 6H13C12.448 6 12 6.447 12 7V25C12 25.553 12.448 26 13 26H14.101C14.566 28.279 16.585 30 19 30C21.415 30 23.434 28.279 23.899 26H31C31.552 26 32 25.553 32 25V16C32 15.523 31.664 15.113 31.196 15.02ZM15 9H22L23.771 14H15V9ZM19 28C17.346 28 16 26.654 16 25C16 23.346 17.346 22 19 22C20.654 22 22 23.346 22 25C22 26.654 20.654 28 19 28Z",
    fill: "#212121"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/deliveryIcon.2ce85881f335375d83b14b5d8ac10e17.svg";
export { ForwardRef as ReactComponent };